export default __webpack_public_path__ + "static/media/sad.2ed81640.svg";